import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outgoing-actions',
  templateUrl: './outgoing-actions.component.html',
  styleUrls: ['./outgoing-actions.component.css']
})
export class OutgoingActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
